import { ExtractPropTypes, PropType } from 'vue'
import type { SelectProps } from 'ant-design-vue/es/select'
import { Required } from 'utility-types'

export const customApiSelectProps = {
  // 双向数据绑定的该组件的值
  value: {
    type: [Number, String, Array] as PropType<number | string | (number | string)[]>,
    default: undefined,
  },
  // 该 picker 获取数据调用的 api
  api: {
    type: Function,
    required: true,
  },
  immediate: Boolean,
  apiParams: {
    type: Object,
    default: () => ({}),
  },
  // 回显id请求名
  PriKeyField: {
    type: String as PropType<string>,
    default: 'id',
  },
  valueField: {
    type: [String, Function],
    default: 'value',
  },
  labelField: {
    type: [String, Function],
    default: 'label',
  },
  resultField: {
    type: String,
    default: 'items',
  },
  zeroToUndefined: {
    type: Boolean,
    default: false,
  },
  // 后端返回id为字符串，前端id数字，设置前端id数字为字符串
  numberToString: {
    type: Boolean,
    default: false,
  },
  pageSize: {
    type: Number,
    default: 1000
  },
  showSearch: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  isPage: {
    type: Number,
    default: 1
  }
}

export type CustomApiSelectProps = Required<Partial<ExtractPropTypes<typeof customApiSelectProps>>, 'api'> & SelectProps